const api = {
  GET_LIST_MASTER_CMER: '/index.php?r=api/v1/cmer/cmer',
  CREATE_MASTER_CMER: '/index.php?r=api/v1/cmer/cmer/create',
  UPDATE_MASTER_CMER: '/index.php?r=api/v1/cmer/cmer/edit',
};

export default api;